export const CrossSellRemoveLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    EXPAND: 'EXPAND',
    CROSS_SELL_REMOVE_INVALID_ACTION: 'CROSS_SELL_REMOVE_INVALID_ACTION',
};
